import { Vehicle as IVehicle } from '@/types';

/**
 * Vehicle data model representing a vehicle from Lua file
 */
export class VehicleModel implements IVehicle {
  name: string;
  brand: string;
  model: string;
  price: number;
  category: string;
  type: string;
  hash: string;
  source: 'lua' | 'xml' | 'manual';

  constructor(data: Partial<IVehicle>) {
    this.name = data.name || '';
    this.brand = data.brand || '';
    this.model = data.model || '';
    this.price = data.price || 0;
    this.category = data.category || '';
    this.type = data.type || '';
    this.hash = data.hash || '';
    this.source = data.source || 'lua';
  }

  /**
   * Get display name for vehicle selection
   */
  getDisplayName(): string {
    if (this.source === 'lua' && this.brand && this.name) {
      return `${this.brand} ${this.name} (${this.category})`;
    }
    return this.model || this.name;
  }

  /**
   * Get detailed info for tooltips
   */
  getDetailedInfo(): string {
    if (this.source === 'lua') {
      return `Brand: ${this.brand}\nCategory: ${this.category}\nPrice: ${this.price.toLocaleString()}`;
    }
    return `Model: ${this.model}`;
  }

  /**
   * Validate vehicle data
   */
  isValid(): boolean {
    return !!(this.model && this.model.length > 0);
  }

  /**
   * Convert to plain object
   */
  toJSON(): IVehicle {
    return {
      name: this.name,
      brand: this.brand,
      model: this.model,
      price: this.price,
      category: this.category,
      type: this.type,
      hash: this.hash,
      source: this.source
    };
  }

  /**
   * Create from plain object
   */
  static fromJSON(data: IVehicle): VehicleModel {
    return new VehicleModel(data);
  }
}
